<app-remote-printer-dropdown
    [dataTestId]="'report-trigger-remote-printer'"
    [selectedId]="selectedId()"
    (valueChange)="onChoice($event)"
/>
@if (invalidOptions()) {
    <small class="text-red-500" data-testid="report-trigger-remote-printer-invalid-options">
        {{ 'report-trigger.remote-printer-invalid-options' | translate }}
    </small>
}
<small class="text-slate-400">{{ 'report-trigger.remote-printer-hint' | translate }}</small>
